<template>
  <div>
    <template v-if="type === 'pc'">
      <Footer :data="pageConfig.footer" />
    </template>
    <template v-else-if="type === 'h5'">
      <MFooter
        :hotline="pageConfig.footer.hotline"
        :other-line="pageConfig.footer.otherLine"
        :siteConfigBanquan="pageConfig.footer.siteConfigBanquan"
        :agreementLink="pageConfig.footer.agreementLink"
        :isPhone="true"
      />
    </template>
  </div>
</template>
<script>
import pageConfig from '@/lib/pageConfig/index.js'
export default {
  props: {
    type: {
      type: String,
      default: 'PC',
    },
  },
  components: {
    Footer: () => import('./PcFooter.vue'),
    MFooter: () => import('./MFooter.vue'),
  },
  data() {
    return {
      pageConfig,
    }
  },
  computed: {},
  methods: {},
}
</script>
